import type { RouteObject } from 'react-router';
import { OnboardingPage } from './OnboardingPage';
import { AwaitingApprovalPage } from './AwaitingApprovalPage';
import { AgentAuthorizePage } from './AgentAuthorizePage';
import { WelcomePage } from './WelcomePage';

export const onboardingRoutes: RouteObject[] = [
  {
    path: '/onboarding',
    element: <OnboardingPage />,
  },
  {
    path: '/awaiting-approval',
    element: <AwaitingApprovalPage />,
  },
  {
    path: '/agent/authorize',
    element: <AgentAuthorizePage />,
  },
  {
    // Registered flat with the others, so it renders outside IdentityGate and AppShell — there is no
    // dashboard worth showing until a device exists, which is the whole reason this flow is full screen.
    path: '/welcome',
    element: <WelcomePage />,
  },
];
